import { Box } from '@xstyled/styled-components';
import ProductCard from '@/UI/ProductCard';
import MobileProductCard from '@/UI/ProductCard/MobileProductCard';
import SkeletonProductCard from '@/UI/Skeletons/SkeletonProductCard';
import MobileSkeletonProductCard from '@/UI/Skeletons/MobileSkeletonProductCard';
import useCatalogue from 'hooks/products/useCatalogue';

export default function Products({ products }) {
  const items = products?.filter(item => item);
  const numArray = [...Array(24)];
  const { loading } = useCatalogue();

  return (
    <>
      {/* Desktop */}
      <Box
        display={{ _: 'none', desktop: 'grid' }}
        gridTemplateColumns="repeat(3, 33.33%)"
        columnGap="1rem"
        rowGap="2rem"
        p="1.5rem 1rem 0 0"
        
      >
        {loading ? (
          <>
            {numArray.map((_, i) => {
              return <SkeletonProductCard key={i} />;
            })}
          </>
        ) : (
          <>
            {items?.map(product => {
              return (
                <ProductCard
                  key={product.sku}
                  product={product}
                  imageSize={{ width: 180, height: 200 }}
                />
              );
            })}
          </>
        )}
      </Box>

      {/* Mobile */}

      <Box
        display={{ _: 'grid', desktop: 'none' }}
        gridTemplateColumns={{ _: '1fr', lg_tablet: '1fr 1fr' }}
        justifyItems={{ sm_tablet: 'center' }}
        columnGap="0.75rem"
        rowGap="0.1rem"
      >
        {loading ? (
          <>
            {numArray?.map((_, i) => {
              return (
                <MobileSkeletonProductCard
                  key={i}
                  // product={product}
                  maxW={450}
                  minH={150}
                />
              );
            })}
          </>
        ) : (
          <>
            {items?.map(product => {
              return (
                <MobileProductCard
                  key={product.sku}
                  product={product}
                  maxW={450}
                  minH={150}
                />
              );
            })}
          </>
        )}
      </Box>
    </>
  );
}
